/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Notes API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NotesResponse,
    NotesResponseFromJSON,
    NotesResponseFromJSONTyped,
    NotesResponseToJSON,
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedNotesResponseList
 */
export interface PaginatedNotesResponseList {
    /**
     * 
     * @type {Pagination}
     * @memberof PaginatedNotesResponseList
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<NotesResponse>}
     * @memberof PaginatedNotesResponseList
     */
    data?: Array<NotesResponse>;
}

export function PaginatedNotesResponseListFromJSON(json: any): PaginatedNotesResponseList {
    return PaginatedNotesResponseListFromJSONTyped(json, false);
}

export function PaginatedNotesResponseListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedNotesResponseList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pagination': PaginationFromJSON(json['pagination']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(NotesResponseFromJSON)),
    };
}

export function PaginatedNotesResponseListToJSON(value?: PaginatedNotesResponseList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pagination': PaginationToJSON(value.pagination),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(NotesResponseToJSON)),
    };
}


